<template>
  <div>
    <model-table
      :collection="newsItems"
      :columns="[
        { field: 'id' },
        { field: 'title' },
        { field: 'newsItemClass', component: 'model' },
        { label: 'Banner', name: 'image', field: 'imageSmallUrl', component: 'img' },
        { name: 'Visibility', field: newsItem => newsItem.displayIcons, component: 'icons' },
        { name: 'library', component: 'library-link', hide: currentCircuit.isLibrary },
        { name: 'actions', align: 'right' }
      ]"
      :has-library="!currentCircuit.isLibrary"
      :library-collection="newsItemLibrary"
      :library-columns="[
        { field: 'title' },
        { field: 'newsItemClass', component: 'model' },
        { label: 'Banner', name: 'image', field: 'imageSmallUrl', component: 'img' }
      ]"
      :link-filter="libraryFilterFunction"
      :orderable="true"
    >
      <news-item-form />
    </model-table>
  </div>
</template>

<script>

import ModelTable from 'src/modules/admin/components/ModelTable'
import NewsItemForm from 'src/modules/admin/news-item/NewsItemForm'

export default {
  name: 'NewsItemTable',
  components: {
    ModelTable,
    NewsItemForm
  },
  configuration: ['currentCircuit'],
  models: {
    newsItems: {
      newsItemClass: 'default',
      visible: 'default',
      libraryParentId: true,
      receiveLibraryUpdates: true
    },
    newsItemLibrary: {
      libraryChildSiteIds: true,
      variables () {
        return {
          searchString: this.libraryFilterString,
          limit: 10
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      libraryFilterString: null
    }
  },
  methods: {
    libraryFilterFunction (value) {
      this.libraryFilterString = !_.isEmpty(value) ? value.trim() : null
    }
  }
}
</script>
